import { render } from "./DeleteProjectModal.vue?vue&type=template&id=5875cade&scoped=true"
import script from "./DeleteProjectModal.vue?vue&type=script&lang=js"
export * from "./DeleteProjectModal.vue?vue&type=script&lang=js"

import "./DeleteProjectModal.vue?vue&type=style&index=0&id=5875cade&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5875cade"]])

export default __exports__